export default {"src":"/org/_next/static/media/whatsapp.2ff5851f.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};